module.exports = __webpack_public_path__ + "img/3.1b144fc8.jpg";